"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { getTimeAgoShort } from "@/helpers/Helpers";
interface BrainLeftSidebarWaveDropTimeProps {
  readonly time: number;
}
const BrainLeftSidebarWaveDropTime: React.FC<BrainLeftSidebarWaveDropTimeProps> = t0 => {
  const $ = _c(9);
  const {
    time
  } = t0;
  const [now, setNow] = useState(_temp);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const intervalId = window.setInterval(() => {
        setNow(Date.now());
      }, 60000);
      return () => {
        window.clearInterval(intervalId);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          setNow(Date.now());
        }
      };
      const handleFocus = () => {
        setNow(Date.now());
      };
      document.addEventListener("visibilitychange", handleVisibilityChange);
      window.addEventListener("focus", handleFocus);
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        window.removeEventListener("focus", handleFocus);
      };
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== now || $[5] !== time) {
    t5 = getTimeAgoShort(time, now);
    $[4] = now;
    $[5] = time;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const label = t5;
  let t6;
  if ($[7] !== label) {
    t6 = <span className="tw-text-iron-300">{label}</span>;
    $[7] = label;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default BrainLeftSidebarWaveDropTime;
function _temp() {
  return Date.now();
}